import { Record } from 'immutable';

import { DcCoreElementType } from '../../core/dc-core-types';
import { AppMetadataEntity } from '../../ui/components/app-metadata/app-metadata.entity';
import { ProjectTraceListEntity } from '../components/project-home/project-trace-list.entity';
import { ProjectPermissionsEntity } from '../domain/project-permissions.entity';

export const HomeSliceKey = 'home';

interface IHomeSliceState {
	loading: boolean;
	metadata: AppMetadataEntity;
	selectedElement: DcCoreElementType;
	traces: ProjectTraceListEntity;
	stat: Map<DcCoreElementType, number>;
	permissions: ProjectPermissionsEntity;
}

const defaults: IHomeSliceState = {
	loading: false,
	metadata: AppMetadataEntity.build(),
	selectedElement: DcCoreElementType.UNKNOWN,
	stat: new Map(),
	traces: ProjectTraceListEntity.build([]),
	permissions: ProjectPermissionsEntity.build(),
};

export class HomeSliceState extends Record<IHomeSliceState>(defaults) {
	public static readonly key = HomeSliceKey;

	public setLoading(isLoading: boolean): HomeSliceState {
		return this.set('loading', isLoading);
	}

	public setSelectedElement(element: DcCoreElementType): HomeSliceState {
		return this.set('selectedElement', element);
	}

	public setMetadata(metadata: AppMetadataEntity): HomeSliceState {
		return this.set('metadata', metadata);
	}

	public setElementsStat(stat: Map<DcCoreElementType, number>): HomeSliceState {
		return this.set('stat', stat);
	}

	public setTraces(traces: ProjectTraceListEntity): HomeSliceState {
		return this.set('traces', traces);
	}

	public setInitialPermissions(permissions: {
		create: boolean;
		edit: boolean;
	}): HomeSliceState {
		return this.set(
			'permissions',
			ProjectPermissionsEntity.build({
				create: permissions.create,
				edit: permissions.edit,
			})
		);
	}

	public changeCreatePermission(create: boolean): HomeSliceState {
		return this.set(
			'permissions',
			this.get('permissions').setElementCreatePermissions(create)
		);
	}
}
